document.addEventListener("DOMContentLoaded", function (event) {
    // countdown
    let productContainer = document.querySelector(".product-details")
    if (productContainer) {
        //   倒计时
        let discountBox = document.querySelector(".new-countdown-container");
        let countdownText = document.querySelector(".new-countdown-container span");
        let countdownBox = document.querySelector(".new-discount-container")
        if (countdownText) {
            function addZero(i) {
                return i < 10 ? "0" + i : i + "";
            }

            let countdownValues;

            function initCountdown() {
                countdownValues = document.querySelector(".new-countdown-container span").getAttribute("data-countdown-value");
                countDown();
            }

            function countDown() {
                var nowtime = new Date();
                var endtime = new Date(countdownValues);
                var lefttime = parseInt((endtime.getTime() - nowtime.getTime()) / 1000);
                var d = parseInt(lefttime / (24 * 60 * 60))
                var h = parseInt(lefttime / (60 * 60) % 24);
                var m = parseInt(lefttime / 60 % 60);
                var s = parseInt(lefttime % 60);
                d = addZero(d)
                h = addZero(h);
                m = addZero(m);
                s = addZero(s);
                countdownText.innerHTML = `Ends in  ${d} Days ${h}:${m}:${s}`;
                if (lefttime <= 0) {
                    countdownBox.parentNode.classList.add('hide')
                    countdownBox.style.display = 'none';
                    discountBox.style.display = 'none';
                    // countdownText.innerHTML = "";
                    return;
                }
                setTimeout(countDown, 1000);
            }

            initCountdown();
        }

    }

    let isScrolling = false;

    const productSection = document.querySelectorAll(".product-section");
    // 获取所有区域和锚链接
    const sections = document.querySelectorAll(".scroll-section");
    const navLinks = document.querySelectorAll(".new-tab-title");
    const navBar = document.querySelector(".new-productView-bar")
    // 创建一个包含每个区域的 offset top 的数组
    const sectionOffsets = Array.from(sections).map(
        (section) => section.offsetTop
    );
    let lastScrollTop = 0;

    function updateNav() {
        if (isScrolling) return;
        isScrolling = true;
        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const direction = currentScrollTop > lastScrollTop ? 'down' : 'up';
        lastScrollTop = currentScrollTop;
        // 获取当前滚动位置
        const scrollPosition = window.scrollY;

        // 循环遍历每个区域的 offsetTop 并检查哪个区域正在视图中
        sectionOffsets.forEach((offset, index) => {
            const offsetTop = sections[index].offsetTop;
            const sectionHeight = sections[index].offsetHeight;
            const isInView =
                scrollPosition >= offset - 60 && scrollPosition < offset + sectionHeight;

            // 如果一个区域正在视图中，就高亮对应的导航链接
            if (isInView) {
                navLinks.forEach((link) =>
                    link.classList.remove("custom_active")
                );
                navLinks[index].classList.add("custom_active");
            }
        });
        setTimeout(() => isScrolling = false, 500);
    }

    window.addEventListener("scroll", () => {
        updateNav();
    });

    const new_product_tab = document.querySelectorAll(".new-tab-heading div");
    new_product_tab.forEach((e) => {
        e.onclick = function () {
            new_product_tab.forEach((a) => {
                a.classList.remove("custom_active")
            })
            e.classList.add("custom_active");
            isScrolling = true;
            setTimeout(() => {
                updateNav();
                isScrolling = false;
            }, 1000);
        }
    })
    const purchase_tab = document.getElementById('new-product-overview-tab');
    if (purchase_tab) {

        const purchase_content = document.querySelector('.product-details');
        const purchaseOffsetTop = purchase_content.offsetTop - 60;
        const overview_tab = document.getElementById('new-product-overview-tab')
        const overview_content = document.querySelector('#new-overview');
        const overviewOffsetTop = overview_content.offsetTop - 60;

        const specs_tab = document.getElementById('new-product-specs-tab')
        const specs_content = document.querySelector('#new-specs');
        const specsOffsetTop = specs_content.offsetTop - 60;

        const faq_tab = document.getElementById('new-product-faqs-tab');
        const faq_content = document.getElementById('faq-tab');
        const faqOffsetTop = faq_content.offsetTop + 220;

        const product_content = document.querySelectorAll("[data-product-content]")
        // const table_tab = document.getElementById('new-product-table-tab');
        // const table_content = document.querySelector('#new-table-tab');
        // const tableOffsetTop = table_content.offsetTop - 60;

        const review_tab = document.getElementById('new-product-reviews-tab');
        const review_content = document.getElementById('judgeme-product-reviews');
        const reviewOffsetTop = review_content.offsetTop - 60;
        
        if (purchase_tab) {
            purchase_tab.addEventListener("click", function (e) {
                window.scrollTo({
                    top: purchaseOffsetTop,
                    behavior: "smooth"
                });
                setTimeout(() => updateNav(), 1000);
            });
        }
        if (overview_tab) {
            overview_tab.addEventListener("click", function (e) {
                window.scrollTo({
                    top: overviewOffsetTop,
                    behavior: "smooth"
                });
                setTimeout(() => updateNav(), 1000);
                for (let index = 0; index < product_content.length; index++) {
                    if(product_content[index].getAttribute('data-product-content')=="ovweview"){
                        product_content[index].style.display="block"
                    }else{
                        product_content[index].style.display="none"
                    }
                }
            });
        }
        for (let index = 0; index < product_content.length; index++) {
            if(product_content[index].getAttribute('data-product-content')=="ovweview"){
                product_content[index].style.display="block"
            }else{
                product_content[index].style.display="none"
            }
        }
        if (specs_tab) {
            specs_tab.addEventListener("click", function (e) {
                window.scrollTo({
                    top: specsOffsetTop,
                    behavior: "smooth"
                });
                setTimeout(() => updateNav(), 1000);
                for (let index = 0; index < product_content.length; index++) {
                    if(product_content[index].getAttribute('data-product-content')=="specs"){
                        product_content[index].style.display="block"
                    }else{
                        product_content[index].style.display="none"
                    }
                }
            });
        }
        // if (table_tab) {

        //     table_tab.addEventListener("click", function (e) {
        //         window.scrollTo({
        //             top: tableOffsetTop,
        //             behavior: "smooth"
        //         });
        //         setTimeout(() => updateNav(), 1000);
        //     });
        // }

        if (faq_tab) {
            faq_tab.addEventListener("click", function (e) {
                window.scrollTo({
                    top: faqOffsetTop,
                    behavior: "smooth"
                });
                setTimeout(() => updateNav(), 1000);
                for (let index = 0; index < product_content.length; index++) {
                    if(product_content[index].getAttribute('data-product-content')=="faqs"){
                        product_content[index].style.display="block"
                    }else{
                        product_content[index].style.display="none"
                    }
                }
            });
        }

        if (review_tab) {
            review_tab.addEventListener("click", function (e) {
                window.scrollTo({
                    top: reviewOffsetTop,
                    behavior: "smooth"
                });
                setTimeout(() => updateNav(), 1000);
                for (let index = 0; index < product_content.length; index++) {
                    if(product_content[index].getAttribute('data-product-content')=="reviews"){
                        product_content[index].style.display="block"
                    }else{
                        product_content[index].style.display="none"
                    }
                }
            });
        }

    }

})